import { startTransition, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AddView, GetNoticeById } from "../../services/NoticeService";
import {
  GetFileByEntityId,
  GetFileById,
  GetFilesEntityId,
} from "../../services/MediumService";
import {
  GetMyPosition,
  GetPositionById,
  GetPositionRoleByPositionIdAndRole,
} from "../../services/PositionService";
// @ts-ignore
import { CreateGroup } from "../../services/MessagingService";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserProfile,
  getMyProfile,
  loggedInProfile,
} from "../../features/profile/profileSlice";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../features/position/positionSlice";
import noImage from "../../assets/vectors/no-image.svg";
import { Units } from "../../helpers/Units";
import CustomButton from "../share/customButton";
import { InsertRowAboveOutlined } from "@ant-design/icons";
import {
  Card,
  Col,
  Collapse,
  Drawer,
  Grid,
  Input,
  InputRef,
  Modal,
  Row,
  Spin,
  Table,
} from "antd";
import { ColorPalette } from "../share/color/colorPalette";
import star from "../../assets/vectors/Star.svg";
import TedSaveIcon from "../icons/TedSaveIcon";
import TedShareIcon from "../icons/TedShareIcon";
import TedItemsIcon from "../icons/TedItemsIcon";
import TedLineIcon from "../icons/TedLineIcon";
import TedEyeIcon from "../icons/TedEyeIcon";
import TedClockIcon from "../icons/TedClockIcon";
import CustomLabel from "../share/customLabel";
import InputWithIcons from "../share/InputWithIcons";
import TextArea from "antd/es/input/TextArea";
import TedTitle from "../share/TedTitle";
import TedArrowRight from "../icons/TedArrowRight";
import {
  //fetchGroups,
  selectAllGroups,
} from "../../features/messages/groupsSlice";
import {
  AddNoticeDetailsAnswereApi,
  GetGroupIdByNoticeIdAndPositionId,
  GetNoticeDetailsAnswere,
  GetNoticeDetailsAnsweresTableByGroupId,
} from "../../services/GroupService";
import toast from "react-hot-toast";
import TedArrowRightBlue from "../icons/TedArrowRightBlue";
import TedArrowLefttBlue from "../icons/TedArrowLeftBlue";
import TedShareWhiteIcon from "../icons/TedShareWhiteIcon";
import TedSaveWhiteIcon from "../icons/TedSaveWhiteIcon";
import TedSearchIcon from "../icons/TedSearchIcon";
import { ColumnsType } from "antd/es/table";
import TedFarayandIcon from "../icons/TedFarayandIcon";
import TedFileIcon from "../icons/TedFileIcon";
import TedFileAttachedIcon from "../icons/TedFileAttachedIcon";
import TedDownloadIcon from "../icons/TedDownloadIcon";
import TedConstructionsGrayIcon from "../icons/TedConstructionsGrayIcon";
import { SendMessage } from "../../services/MessageService";
import TedPrintIcon from "../icons/TedPrintIcon";
import ConvertToShamsiWithOut330 from "../../extentions/convertors/ConvertToShamsiWithOut330";
import ConvertToShamsi from "../../extentions/convertors/ConvertToShamsi";
import TedOneLineChatIcon from "../icons/TedOneLineChatIcon";
const { useBreakpoint } = Grid;

const Notice8 = (position: any) => {
  const printRef = useRef<HTMLDivElement>(null);
  const handlePrint = () => {
    if (printRef.current) {
      const printContent = printRef.current.innerHTML;
      const printWindow = window.open("", "", "width=800,height=600");
      if (printWindow) {
        printWindow.document.write(`
          <html>
          <head>
            <title>Print Table</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 20px; direction: rtl; }
              table { width: 100%; border-collapse: collapse; direction: rtl; }
              th, td { border: 1px solid black; padding: 8px; text-align: right; } /* Align text to right */
              th { background-color: #f0f0f0; }
              @media print {
                button { display: none; } /* Hide buttons when printing */
              }
            </style>
          </head>
          <body>
          <div style=" text-align:center" >
      <b>گزارش   قیمت دهی سامانه دیجیتال آگهی</b>
    </div>
            <br/> <br/>
           ${"تاریخ چاپ:"}
           
          ${ConvertToShamsiWithOut330(new Date())}
           <br/> <br/>
            ${"بابت آگهی:"}
           ${data.title}
                <br/> <br/>
            ${printContent}
          </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
      }
    }
  };

  const screens = useBreakpoint();
  const [getAnsweres, setAnsweres] = useState<any>([]);
  const params = useParams();
  useEffect(() => {
    console.log("params.Id");

    setAnsweres([]);
    setIsLoading(true);
    setSelectedNoticeId(params.id);
    if (profileStatus === "idle") {
      dispatch(fetchUserProfile());
    }

    if (positionStatus === "idle") {
      dispatch(fetchUserPosition());
    }
    AddViewTo();

    getProductbyId();
    GetFilesAsync();

    //ForChat
    //dispatch(fetchGroups());
  }, [params.id]);
  //ForChat Start
  const groupList = useSelector(selectAllGroups);
  const [getMyPositionData, SetMyPositionData] = useState<any>(null);
  const [getSelectedGroupId, setSelectedGroupId] = useState<any>(null);
  const [getSelectedNoticeId, setSelectedNoticeId] = useState<any>(null);
  const [positionId, setPositionId] = useState(null);
  const [getSendingSatte, setSendingSatte] = useState(false);
  const [getValidToSend, setValidToSend] = useState(false);
  const [getIsEdit, setIsEdit] = useState(false);

  const [selectedGroup, setSelectedGroup] = useState(null);
  const [getIsPrinting, setIsPrinting] = useState(false);

  const myPositions = useSelector(getMyPosition);

  useEffect(() => {
    console.log("myPositions");
    if (myPositions.positions.id !== "") {
      setPositionId(myPositions.positions.id);
    }
  }, [myPositions]);

  useEffect(() => {
    console.log("getSelectedNoticeId");
    if (
      getSelectedNoticeId !== undefined &&
      getSelectedNoticeId !== null &&
      positionId !== null &&
      positionId !== undefined
    ) {
      GetGroupIdByNoticeIdAndPositionId(getSelectedNoticeId, positionId).then(
        (p) => {
          setSelectedGroupId(p.data.data);
          return;
        }
      );
    }
  }, [getSelectedNoticeId, positionId]);

  useEffect(() => {
    console.log("getSelectedGroupId");

    if (getSelectedGroupId !== null && getSelectedGroupId !== undefined) {
      GetNoticeDetailsAnswere(getSelectedGroupId).then((p: any) => {
        //console.log("smp", p);
        if (Array.isArray(p?.data?.data)) {
          const answersWithSavedProperty = p.data.data?.map((answer: any) => ({
            ...answer,
            Saved: true,
            Calculated: true,
          }));
          setAnsweres(answersWithSavedProperty);
        }
      });
    }
  }, [getSelectedGroupId]);

  useEffect(() => {
    console.log("groupList");

    if (getSelectedNoticeId !== null && getSelectedNoticeId !== undefined) {
      groupList.some((obj: any) => {
        return obj.groupRefs.some((ref: any) => {
          if (ref.noticeId === getSelectedNoticeId) {
            setSelectedGroup(obj.id);
            console.log("setSelectedGroup", obj.id);

            return true; // exits the loop once the condition is met
          }
        });
      });
    }
  }, [groupList]);

  //ForChatEnd
  const location = useLocation();
  const SetAnswereForNoticeDetail = (id: any, name: any, value: any) => {
    //Setfailed(null);
    setValidToSend(true);
    navigate(`/notice/${data.id}?flag=Edited`);
    const index = getAnsweres.findIndex((p: any) => p.noticeDetailId === id);
    console.log("index , name , value", index, name, value);
    console.log(
      "cnt",
      data.noticeDetails[data.noticeDetails.findIndex((p: any) => p.id === id)]
        .count
    );

    if (index === -1) {
      console.log("window.location.pathname ", window.location.pathname);

      setAnsweres((prevItems: any) => [
        ...prevItems,
        {
          noticeDetailId: id,
          ["Saved"]: false,
          ["Calculated"]: false,
          ["count"]:
            name !== "count"
              ? data.noticeDetails[
                  data.noticeDetails.findIndex((p: any) => p.id === id)
                ].count
              : value.replace(/[^0-9]/g, ""),
          ["price"]: name !== "price" ? "" : value.replace(/[^0-9]/g, ""),
          [name]: name !== "description" ? value.replace(/[^0-9]/g, "") : value,
          ["vat"]:
            data.noticeDetails[
              data.noticeDetails.findIndex((p: any) => p.id === id)
            ].vat,
        },
      ]);
    } else {
      console.log("cntC", getAnsweres[index]);

      setAnsweres((prevItems: any) =>
        prevItems?.map((item: any) =>
          item.noticeDetailId === id
            ? {
                ...item,
                ["Saved"]: false,
                ["Calculated"]: false,
                [name]:
                  name !== "description" ? value.replace(/[^0-9]/g, "") : value,
              }
            : item
        )
      );
    }
  };

  const profileStatus = useSelector((state) => (state as any).profiles.status);

  const positionStatus = useSelector(
    (state) => (state as any).positions.status
  );

  const dispatch = useDispatch<any>();
  const myProfile = useSelector(getMyProfile);
  const loggedin = useSelector(loggedInProfile);
  const [visibleChat, setVisibleChat] = useState(false);

  const [data, setData] = useState<any>(null);

  const [FileLoadedView, SetFileLoadedView] = useState<any>(null);
  async function GetFilesAsync() {
    await GetFilesEntityId(params.id).then((p) => {
      SetFileLoadedView(p.data.data);
    });
  }

  const [clientHeight, setClientHeight] = useState(0);

  const [clientWidth, setClientWidth] = useState(0);

  useEffect(() => {
    setIsEdit(false);
    console.log("[]");
    setAnsweres([]);
    setClientWidth(document.documentElement.clientWidth);
    setClientHeight(document.documentElement.clientHeight);
    console.log("params.id", params.id);
    setSelectedNoticeId(params.id);
    if (profileStatus === "idle") {
      dispatch(fetchUserProfile());
    }

    if (positionStatus === "idle") {
      dispatch(fetchUserPosition());
    }
    AddViewTo();

    getProductbyId();
    GetFilesAsync();

    //End ForChat
    //dispatch(fetchGroups());

    //End ForChat

    const handleResize = () => {
      setClientWidth(document.documentElement.clientWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [StartChat, setStartChat] = useState(false);

  async function GetPositionRoleByPositionIdAndRoleAsync3(positionId: any) {
    await GetPositionRoleByPositionIdAndRole(positionId, "StartChat").then(
      (p) => {
        console.log("setStartChat", p.data.data);

        setStartChat(p.data.data);
      }
    );
  }
  async function AddViewTo() {
    await AddView({
      noticeId: params.id,
    }).then((p) => console.log("dat3", myPositions));
  }

  const checkVisibleChat = (companyId: any, companyId2: any) => {
    console.log("ChatCmp", companyId2);
    console.log("Chatcmpid", companyId);

    if (companyId2 === companyId) {
      console.log("Chat", "false");

      setVisibleChat(false);
    } else {
      setVisibleChat(true);
    }
  };

  async function CreateGroupAsync() {
    //console.log("wph", `${window.location.host}/Chat`);

    //return;
    await CreateGroup({ noticeId: params.id }).then(() => {
      //navigate("/chat");
      //window.parent.location.href = `http://${window.location.host}/Chat/${params.id}`;
      window.parent.location.href = `http://${window.location.host}/Chat/${params.id}`;
    });
  }
  useEffect(() => {
    if (data) {
      GetPositionById((data as any)?.responsiblePositionId).then((p) => {
        GetMyPosition().then((q) => {
          checkVisibleChat(q.data?.companyId, p.data.companyId);
          GetPositionRoleByPositionIdAndRoleAsync3(q.data?.id);
        });
      });

      if (data && (data as any)?.image === null) {
        getProductFilebyId();
      }
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === "Enter" && e.target === document.body) {
          console.log("dataaaaNot", e);
          console.log(
            "Enter Pressed",
            getOpenCollapce,
            data?.noticeDetails[0].id
          );

          setActiveKey(data?.noticeDetails[0].id);
          setOpenCollapce(data?.noticeDetails[0].id);
        }
      };

      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [data]);

  const getProductFilebyId = async () => {
    await GetFileByEntityId((data as any)?.id).then((p) => {
      setData({
        ...(data as any),
        ["image"]: p.data === "" ? noImage : p.data,
      });
    });
  };
  const getProductbyId = async () => {
    await GetNoticeById(params.id)
      .then((p) => {
        setData(p.data);
        console.log("dataFromServer", p.data);
      })
      .then(() => setIsLoading(false));
  };
  const navigate = useNavigate();

  async function handleDownload(id: any, fileName: any) {
    await GetFileById(id)
      .then((response) => {
        console.log(response);

        // Create a blob object from the response
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();

        // Clean up
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        // Handle download error
      });
  }

  const guidToNumber = (guid: string): number => {
    // Convert Guid string to a byte array (using the first 8 bytes)
    const bytes = guid
      .replace(/-/g, "") // Remove hyphens
      .match(/.{1,2}/g) // Split into pairs of hex digits
      ?.slice(0, 8) // Take the first 8 bytes (16 hex digits)
      .map((byte) => parseInt(byte, 16)); // Convert to integers

    if (!bytes) throw new Error("Invalid Guid format");

    // Combine these bytes into a single number
    let number = 0;
    for (let i = 0; i < bytes.length; i++) {
      number = number * 256 + bytes[i]; // Shift left and add the byte
    }

    return number;
  };

  function convertToPersianNumbers(number: any) {
    if (number === undefined) {
      return;
    }
    const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return number.toString().replace(/\d/g, (d: any) => persianDigits[d]);
  }

  const SaveAnswereForNoticeDetail = (data: any, id: any) => {
    console.log(data);
    setSendingSatte(true);
    CreateGroup({
      noticeId: params.id,
      positionId: myPositions.positions.id,
      companyId: myPositions.positions.company.id,
      noticeDetailAnsweres: data,
    }).then((p) => {
      toast.success("قیمت های شما با موفقیت به آگهی دهنده فرستاده شدند");
      setSendingSatte(false);
      setIsEdit(true);
      setValidToSend(false);
      navigate(location.pathname);
    });
    return;
  };

  useEffect(() => {
    console.log("getAnsweres", getAnsweres);

    if (getAnsweres !== null && getAnsweres !== undefined) {
      if (getAnsweres.filter((a: any) => a.Saved).length > 0) {
        setIsEdit(true);
      }
      handleUpdateToCalculate();
    } else {
      setIsEdit(false);
    }
    //console.log("getAnsweres", getAnsweres);
  }, [getAnsweres]);
  const handleUpdateToCalculate = () => {
    // Check if there's any answer with Saved set to false
    const hasUnsavedAnswers = getAnsweres.some(
      (answer: any) => !answer.Calculated && !answer.Saved
    );
    //  console.log("hasUnsavedAnswers", hasUnsavedAnswers);

    // If there are unsaved answers, update their prices
    if (hasUnsavedAnswers) {
      const updatedAnswers = getAnsweres.map((answer: any) =>
        answer.Calculated === false &&
        answer.Saved === false &&
        answer.count !== undefined &&
        answer.price !== undefined
          ? {
              ...answer,
              totalPrice:
                Number.parseInt(answer.price) * Number.parseInt(answer.count),
              totalVat: Math.round(
                Number.parseInt(answer.price) *
                  Number.parseInt(answer.count) *
                  Number.parseFloat(
                    data.noticeDetails[
                      data.noticeDetails.findIndex(
                        (p: any) => p.id === answer.noticeDetailId
                      )
                    ].vat
                  )
              ),

              totalPriceWithVat: Math.round(
                Number.parseInt(answer.price) * Number.parseInt(answer.count) +
                  Number.parseInt(answer.price) *
                    Number.parseInt(answer.count) *
                    Number.parseFloat(
                      data.noticeDetails[
                        data.noticeDetails.findIndex(
                          (p: any) => p.id === answer.noticeDetailId
                        )
                      ].vat
                    )
              ),
              Calculated: true,
            }
          : answer
      );
      //console.log("updatedAnswers", updatedAnswers);
      setAnsweres(updatedAnswers);
    }
  };

  const columnsTotal: ColumnsType<any> = [
    {
      title: "#", // Row Index Title
      dataIndex: "index", // Create an index column
      key: "index",
      width: "5%", // Adjust width for index column
      align: "center",
      render: (_: any, __: any, index: number) => index + 1, // Display 1-based index (index starts from 0)
    },
    {
      title: "عنوان",
      dataIndex: "companyName",
      key: "companyName",
      width: "33%",
      sorter: false,
      align: "center", // Center align header & content
      render: (item, record, index) =>
        data?.noticeDetails?.some(
          (data: any) => data.id === record?.noticeDetailId
        )
          ? data?.noticeDetails.find(
              (data: any) => data.id === record?.noticeDetailId
            )?.title
          : "",
    },
    {
      title: "تعداد",
      dataIndex: "count",
      key: "count",
      width: "10%",
      sorter: false,
      align: "center",
      render: (item, record) =>
        record?.count
          ?.toString()
          ?.replace(/[^0-9]/g, "")
          ?.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    },
    {
      title: "قیمت واحد",
      dataIndex: "price",
      key: "price",
      width: "10%",
      sorter: false,
      align: "center",
      render: (item, record) =>
        record?.price
          ?.toString()
          ?.replace(/[^0-9]/g, "")
          ?.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    },
    {
      title: "قیمت کل",
      dataIndex: "totalPrice",
      key: "totalPrice",
      width: "20%",
      sorter: false,
      align: "center",
      render: (item, record) =>
        record?.totalPrice
          ?.toString()
          ?.replace(/[^0-9]/g, "")
          ?.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    },
    {
      title: "کل مالیات",
      dataIndex: "totalVat",
      key: "totalVat",
      width: "10%",
      sorter: false,
      align: "center",
      render: (item, record) =>
        record?.totalVat
          ?.toString()
          ?.replace(/[^0-9]/g, "")
          ?.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    },
    {
      title: "مبلغ کل با مالیات",
      dataIndex: "totalPriceWithVat",
      key: "totalPriceWithVat",
      width: "20%",
      sorter: false,
      align: "center",
      render: (item, record) =>
        record?.totalPriceWithVat
          ?.toString()
          ?.replace(/[^0-9]/g, "")
          ?.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    },
  ];

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openDrawerFile, setOpenDrawerFile] = useState(false);
  const [activeKey, setActiveKey] = useState([]);
  useEffect(() => {
    console.log("activeKey[0]", activeKey.toString());

    setOpenCollapce(activeKey.toString());
  }, [activeKey]);
  const SubmitChange = () => {
    getAnsweres.map((p: any) => {
      console.log("map getansweres ", p);
      toast.success("قیمت ها با موفقیت ثبت شدند");
      // SaveAnswereForNoticeDetail(p.id);
    });
  };

  const [getIsLoading, setIsLoading] = useState(false);
  const contentStyle: React.CSSProperties = {
    padding: 50,
    borderRadius: 4,
  };
  const content = <div style={contentStyle} />;

  //Prices ref start
  const [getPriceRefFocus, setPriceRefFocus] = useState("");
  const priceRefInputs = useRef<Map<string, InputRef>>(new Map());

  const [getOpenCollapce, setOpenCollapce] = useState("");
  const collapceRefsRefs = useRef<Map<string, HTMLDivElement>>(new Map());
  useEffect(() => {
    console.log("getOpenCollapce");

    if (!getOpenCollapce) return;

    setTimeout(() => {
      const selectedCard = collapceRefsRefs.current.get(getOpenCollapce);
      //console.log("datattt", selectedCard);

      if (selectedCard) {
        selectedCard.scrollIntoView({ behavior: "smooth", block: "center" });

        setTimeout(() => {
          const selectedInput = priceRefInputs?.current?.get(getOpenCollapce);
          selectedInput?.input?.focus();
        }, 300);
      }
    }, 100);
  }, [getOpenCollapce]);
  //Scrollable Items End
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      console.log("dataaaHe");

      const focusableElements = Array.from(
        document.querySelectorAll<HTMLElement>(
          'input, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => !el.hasAttribute("disabled"));

      const currentIndex = focusableElements.indexOf(e.target as HTMLElement);
      const nextElement = focusableElements[currentIndex + 1];

      if (nextElement) {
        nextElement.focus();
      }
    }
  };
  //Columns Of Table
  const columnsOfEnterPriceTable: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",

      align: "center",
      render: (item, record, index) => (
        <>
          <> {index + 1} </>
        </>
      ),
    },
    {
      title: "عنوان",
      dataIndex: "title",
      key: "title",

      align: "center",
      render: (item, record, index) => <>{record.title} </>,
    },

    {
      title: "تعداد و  واحد",
      dataIndex: "title",
      key: "title",

      align: "center",
      render: (item, record, index) => (
        <>
          {record.count}{" "}
          {
            Units[
              Units.findIndex((f: any) => f.value === record.unit.toString())
            ].label
          }
        </>
      ),
    },
    {
      title: "ارزش افزوده",
      dataIndex: "title",
      key: "title",

      align: "center",
      render: (item, record, index) => (
        <>
          {record.vat * 100} {"%"}{" "}
        </>
      ),
    },
    {
      title: "قیمت واحد (ریال)	",
      dataIndex: "price",
      key: "price",

      align: "center",
      render: (item, record, index) => (
        <>
          <InputWithIcons
            disabled={!(visibleChat && StartChat)}
            ref={(el: any) => {
              priceRefInputs.current.set(record.id, el);
            }}
            className="no-print"
            onKeyDown={handleKeyDown}
            onChange={(d) =>
              SetAnswereForNoticeDetail(record.id, "price", d.target.value)
            }
            value={getAnsweres[
              getAnsweres.findIndex(
                (f: any) => f?.noticeDetailId === record?.id
              )
            ]?.price
              ?.toString()
              ?.replace(/[^0-9]/g, "")
              ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            size="xlarge"
            style={{
              width: "200px",
            }}
          />
        </>
      ),
    },

    {
      title: "قیمت کل	",
      dataIndex: "title",
      key: "title",

      align: "center",
      render: (item, record) => {
        return (
          <>
            {Number.isNaN(
              Math.round(
                Number.parseInt(
                  getAnsweres[
                    getAnsweres.findIndex(
                      (f: any) => f?.noticeDetailId === record?.id
                    )
                  ]?.price
                ) * Number.parseInt(record?.count)
              )
            )
              ?.toString()
              ?.replace(/[^0-9]/g, "")
              ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              ? ""
              : Math.round(
                  Number.parseInt(
                    getAnsweres[
                      getAnsweres.findIndex(
                        (f: any) => f?.noticeDetailId === record?.id
                      )
                    ]?.price
                  ) * Number.parseInt(record?.count)
                )
                  ?.toString()
                  ?.replace(/[^0-9]/g, "")
                  ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </>
        );
      },
    },
    {
      title: "مالیات و عوارض	",
      dataIndex: "title",
      key: "title",

      align: "center",
      render: (item, record) => {
        return (
          <>
            {Number.isNaN(
              Number.parseInt(
                getAnsweres[
                  getAnsweres.findIndex(
                    (f: any) => f?.noticeDetailId === record?.id
                  )
                ]?.price
              ) *
                Number.parseInt(record?.count) *
                Number.parseFloat(record?.vat)
            )
              ?.toString()
              ?.replace(/[^0-9]/g, "")
              ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              ? ""
              : Math.round(
                  Number.parseInt(
                    getAnsweres[
                      getAnsweres.findIndex(
                        (f: any) => f?.noticeDetailId === record?.id
                      )
                    ]?.price
                  ) *
                    Number.parseInt(record?.count) *
                    Number.parseFloat(record?.vat)
                )
                  ?.toString()
                  ?.replace(/[^0-9]/g, "")
                  ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </>
        );
      },
    },
    {
      title: "مبلغ کل با مالیات",
      dataIndex: "title",
      key: "title",

      align: "center",
      render: (item, record) => {
        return (
          <>
            {Number.isNaN(
              Math.round(
                Number.parseInt(
                  getAnsweres[
                    getAnsweres.findIndex(
                      (f: any) => f?.noticeDetailId === record?.id
                    )
                  ]?.price
                ) *
                  Number.parseInt(record?.count) +
                  Number.parseInt(
                    getAnsweres[
                      getAnsweres.findIndex(
                        (f: any) => f?.noticeDetailId === record?.id
                      )
                    ]?.price
                  ) *
                    Number.parseInt(record?.count) *
                    Number.parseFloat(record?.vat)
              )
                ?.toString()
                ?.replace(/[^0-9]/g, "")
                ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            )
              ? ""
              : Math.round(
                  Number.parseInt(
                    getAnsweres[
                      getAnsweres.findIndex(
                        (f: any) => f?.noticeDetailId === record?.id
                      )
                    ]?.price
                  ) *
                    Number.parseInt(record?.count) +
                    Number.parseInt(
                      getAnsweres[
                        getAnsweres.findIndex(
                          (f: any) => f?.noticeDetailId === record?.id
                        )
                      ]?.price
                    ) *
                      Number.parseInt(record?.count) *
                      Number.parseFloat(record?.vat)
                )
                  ?.toString()
                  ?.replace(/[^0-9]/g, "")
                  ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </>
        );
      },
    },
  ];
  //End Columns OF Table

  const [mappedData, setMappedData] = useState<[]>([]);
  useEffect(() => {
    console.log("data 2");

    if (data?.noticeDetails) {
      console.log("data?.noticeDetails", data?.noticeDetails);

      const transformedData = data.noticeDetails.map((item: any) => ({
        ...item,
        key: item.id,
      }));
      setMappedData(transformedData);
    }
  }, [data]);

  const [expandedRowIds, setExpandedRowIds] = useState<[]>([]);

  return (
    <>
      {getIsLoading ? (
        <Row style={{ width: "100%", height: clientHeight }}>
          <Col
            style={{
              backgroundColor: "gray",
              width: "100%",
              height: clientHeight,
            }}
          >
            <Spin
              style={{ width: "100%", height: clientHeight, margin: "auto" }}
              fullscreen={false}
              tip="درحال بارگذاری"
              size="large"
            >
              {content}
            </Spin>
          </Col>
        </Row>
      ) : (
        <>
          {!screens.xs && clientWidth > 1510 ? (
            <>
              <Row
                className="px-2"
                style={{
                  width: "100%",
                  overflow: "scroll",
                  scrollMargin: "1px",
                  scrollPaddingRight: "1px",
                }}
              >
                <Col style={{ backgroundColor: "transparent", width: "100%" }}>
                  <Row
                    className="iran"
                    style={{ marginTop: "8px", width: "100%" }}
                  >
                    <Card
                      className="noticeView containxer"
                      style={{
                        borderRadius: "0px 0px 0px 0px",
                        border: "0px",
                        height: "100%",
                        width: "100%",
                        scrollbarWidth: "none",
                        backgroundColor: "transparent",
                      }}
                    >
                      <Row
                        style={{
                          height: "48px",
                          width: "100%",
                          margin: "auto",
                          direction: "ltr",
                          backgroundColor: "transparent",
                        }}
                      >
                        <span
                          style={{
                            width: "32px",
                            height: "32px",
                            textAlign: "center",
                          }}
                        >
                          <TedSaveIcon />
                        </span>
                        <span
                          style={{
                            width: "32px",
                            height: "32px",
                            textAlign: "center",
                          }}
                        >
                          <TedShareIcon />
                        </span>
                      </Row>
                      <Row
                        style={{
                          height: "18px",
                          width: "100%",
                          margin: "auto",
                          direction: "ltr",
                          backgroundColor: "transparent",
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "YekanBakhVF",
                            fontSize: "10px",
                            fontWeight: "450",
                            display: "inline-flex",
                            color: ColorPalette.gray[500],
                          }}
                        >
                          <span> آیتم &nbsp;</span>
                          <span>
                            {convertToPersianNumbers(
                              data?.noticeDetails?.length
                            )}
                          </span>
                          <span style={{ marginLeft: "4px" }}>
                            <TedItemsIcon />
                          </span>
                          <span
                            style={{ marginLeft: "8px", marginRight: "8px" }}
                          >
                            <TedLineIcon />
                          </span>
                          <span>{convertToPersianNumbers(3)}</span>
                          <span style={{ marginLeft: "4px" }}>
                            <TedEyeIcon />
                          </span>
                          <span
                            style={{ marginLeft: "8px", marginRight: "8px" }}
                          >
                            <TedLineIcon />
                          </span>
                          <span>
                            {ConvertToShamsi((data as any)?.createdDate)}{" "}
                          </span>

                          <span style={{ marginLeft: "4px" }}>
                            <TedClockIcon />
                          </span>
                        </div>
                      </Row>
                      <Row
                        style={{
                          marginTop: "24px",
                          marginRight: "20px",
                          marginLeft: "20px",
                        }}
                      >
                        <Col
                          style={{
                            fontSize: "14px",
                            fontWeight: "450",
                            lineHeight: "25.2px",
                            fontFamily: "YekanBakhVF",
                            color: ColorPalette.gray[950],
                          }}
                        >
                          {data?.title}
                        </Col>
                      </Row>
                      <hr />
                      <Row style={{ width: "100%" }}>
                        <Col style={{ width: "100%" }}>
                          <Row
                            style={{
                              width: "100%",
                              margin: "auto",
                              marginTop: "20px",
                              textAlign: "center",
                            }}
                          >
                            <Col style={{ width: "157px" }}>
                              <span
                                onClick={() => setOpenDrawer(true)}
                                style={{
                                  fontFamily: "YekanBakhVF",
                                  display: "inline-flex",
                                  cursor: "pointer",
                                  color: ColorPalette.primaryBlue[500],
                                }}
                              >
                                <TedFarayandIcon />
                                &nbsp; فرآیند آگهی (
                                {convertToPersianNumbers(
                                  data?.noticeLevels?.length
                                )}
                                )
                              </span>
                            </Col>
                            <Col style={{ width: "157px" }}>
                              <span
                                onClick={() => setOpenDrawerFile(true)}
                                style={{
                                  fontFamily: "YekanBakhVF",
                                  display: "inline-flex",
                                  cursor: "pointer",
                                  color: ColorPalette.primaryBlue[500],
                                }}
                              >
                                <TedFileIcon />
                                &nbsp; فایل پیوست (
                                {FileLoadedView?.length === undefined
                                  ? 0
                                  : convertToPersianNumbers(
                                      FileLoadedView?.length
                                    )}
                                )
                              </span>
                            </Col>

                            <Col
                              style={{
                                width: "157px",
                                display:
                                  StartChat && visibleChat ? "block" : "none",
                              }}
                            >
                              <span
                                onClick={() => {
                                  CreateGroupAsync();
                                }}
                                style={{
                                  fontFamily: "YekanBakhVF",
                                  display: "inline-flex",
                                  cursor: "pointer",
                                  color: ColorPalette.primaryBlue[500],
                                }}
                              >
                                <TedOneLineChatIcon />
                                &nbsp; گفتگو
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row
                        style={{
                          marginTop: "24px",
                          marginRight: "20px",
                          marginLeft: "20px",
                          marginBottom: "30px",

                          color: ColorPalette.gray[950],
                        }}
                      >
                        <Col>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "300",
                              lineHeight: "25.2px",
                              fontFamily: "YekanBakhVF",
                            }}
                          >
                            {data?.description}
                          </span>
                        </Col>
                      </Row>
                      <Row
                        className="mt-2"
                        ref={printRef}
                        style={{ margin: "auto" }}
                      >
                        <Table
                          style={{ width: "100%" }}
                          dataSource={mappedData}
                          columns={columnsOfEnterPriceTable}
                          expandable={{
                            expandedRowRender: (record) => (
                              <p style={{ margin: 0 }}>
                                <InputWithIcons
                                  placeholder="توضیحات"
                                  onKeyDown={handleKeyDown}
                                  onChange={(d) =>
                                    SetAnswereForNoticeDetail(
                                      record.id,
                                      "description",
                                      d.target.value
                                    )
                                  }
                                  value={
                                    getAnsweres[
                                      getAnsweres.findIndex(
                                        (f: any) =>
                                          f?.noticeDetailId === record?.id
                                      )
                                    ]?.description
                                  }
                                  size="xlarge"
                                  style={{
                                    width: "100%",
                                  }}
                                />
                              </p>
                            ),
                            rowExpandable: (record) => record.title !== "",
                          }}
                          pagination={false}
                        />
                      </Row>
                      <Row
                        style={{
                          width: "100%",

                          marginTop: "20px",
                        }}
                      >
                        <CustomButton
                          disabled={
                            getSendingSatte == true || getValidToSend == false
                          }
                          onClick={() => {
                            if (getAnsweres.length > 0) {
                              {
                                SaveAnswereForNoticeDetail(getAnsweres, 0);
                              }
                            } else {
                              toast.error("هیچ قیمتی ثبت نشده است");
                            }
                            //
                          }}
                          hasTitle
                          customSize="XLarge"
                          customType="Primary"
                          style={{
                            marginTop: "20px",
                            margin: "auto",
                            width: "320px",
                            height: "48px",
                            // display:
                            //   visibleChat === true && StartChat === true
                            //     ? "block"
                            //     : "none",
                          }}
                        >
                          {getIsEdit ? <>ویرایش و ارسال</> : <>تایید و ارسال</>}
                        </CustomButton>
                        <CustomButton
                          onClick={handlePrint}
                          hasTitle
                          LeftIcon={TedPrintIcon}
                          LeftIconEnabled
                          customSize="XLarge"
                          customType="Primary"
                          style={{
                            marginTop: "20px",
                            margin: "auto",
                            width: "320px",
                            height: "48px",
                          }}
                        >
                          چاپ{" "}
                        </CustomButton>
                      </Row>
                      <Row style={{ height: "600px" }}></Row>
                    </Card>
                  </Row>
                </Col>
              </Row>
              <Modal
                open={getSendingSatte}
                footer={null}
                onCancel={() => setSendingSatte(false)}
              >
                <Row className="mt-4">
                  <CustomLabel style={{ marginLeft: "10px" }}>
                    در حال ارسال لیست قیمت به آگهی دهنده هستیم
                  </CustomLabel>
                  <Spin size="large" />
                </Row>
              </Modal>
              <Drawer
                title=""
                placement={"bottom"}
                width={360}
                onClose={() => setOpenDrawer(false)}
                open={openDrawer}
              >
                <div>
                  <ol
                    style={{
                      color: "black",
                      textAlign: "right",
                      fontFamily: "YekanBakhVF",
                      fontSize: "16px",
                      fontWeight: "325",
                      lineHeight: "28.8px",
                    }}
                  >
                    {data?.noticeLevels?.map((p: any) => {
                      return <li key={p.key}>{p.level}</li>;
                    })}
                  </ol>
                </div>
              </Drawer>
              <Drawer
                title=""
                placement={"bottom"}
                width={360}
                onClose={() => setOpenDrawerFile(false)}
                open={openDrawerFile}
              >
                <div>
                  {FileLoadedView?.map((p: any) => {
                    return (
                      <div
                        key={p.id}
                        style={{
                          textAlign: "center",
                          display: "block",
                          cursor: "pointer",
                          fontFamily: "YekanBakhVF",
                        }}
                      >
                        <div style={{ display: "inline-flex" }}>
                          <TedFileAttachedIcon />
                          <span
                            style={{
                              width: "148px",
                              fontSize: "16px",
                              fontWeight: "325",
                            }}
                          >
                            {p.name}
                          </span>

                          <span
                            onClick={() => handleDownload(p.id, p.name)}
                            style={{
                              direction: "ltr",
                              width: "148px",
                              fontSize: "14px",
                              fontWeight: "450",
                              color: ColorPalette.primaryBlue[500],
                              display: "inline-flex",
                            }}
                          >
                            {"دانلود فایل"} <TedDownloadIcon />
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Drawer>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <Row style={{ height: "500px" }}>
                <br />
                <br />
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "350px",
                    zIndex: -1,
                    backgroundColor: ColorPalette.primaryBlue[600],
                  }}
                >
                  <img src={star} height={"50%"} />
                </Col>
                <Col>
                  <Row className="mt-3">
                    <Col
                      onClick={() => navigate(-1)}
                      className="mx-2"
                      style={{ marginTop: "14px" }}
                    >
                      <TedArrowRight />
                    </Col>
                    <Col style={{ display: "block", width: "197px" }}>
                      <Row className="noPadding">
                        <CustomLabel
                          customSize="XLarge"
                          style={{
                            display: "block",
                            fontSize: "14px",
                            fontWeight: "325",
                            color: "white",
                          }}
                        >
                          شماره آگهی:
                        </CustomLabel>
                      </Row>
                      <Row>
                        <CustomLabel
                          customSize="XLarge"
                          style={{
                            display: "block",
                            fontSize: "14px",
                            fontWeight: "325",
                            color: "white",
                          }}
                        >
                          {(data as any)?.id !== undefined ? (
                            guidToNumber((data as any)?.id)
                          ) : (
                            <></>
                          )}
                        </CustomLabel>
                      </Row>
                    </Col>
                    <Col
                      style={{
                        width: "112px",
                        direction: "ltr",
                        marginTop: "17px",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#FFFFFF1A",
                          height: "36px",
                          width: "36px",
                          borderRadius: "8px",
                          marginRight: "8px",
                          display: "inline-flex",
                        }}
                      >
                        <span
                          style={{
                            display: "block",
                            paddingLeft: "7px",
                            paddingTop: "5px",
                          }}
                        >
                          <TedSaveWhiteIcon />
                        </span>
                      </div>
                      <div
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#FFFFFF1A",
                          height: "36px",
                          width: "36px",
                          borderRadius: "8px",
                        }}
                      >
                        <span
                          style={{
                            display: "block",
                            paddingLeft: "7px",
                            paddingTop: "5px",
                          }}
                        >
                          <TedShareWhiteIcon />
                        </span>
                      </div>
                    </Col>
                  </Row>
                  <Row className="iran" style={{ marginTop: "8px" }}>
                    <Card
                      className="noticeView containxer"
                      style={{
                        borderRadius: "0px 0px 0px 0px",
                        position: "fixed",
                        height: "100%",
                        width: "100%",
                        scrollbarWidth: "none",
                        backgroundColor: "white",
                      }}
                    >
                      <section className="item">
                        {" "}
                        <Row
                          style={{
                            marginTop: "0px",
                            width: "100%",
                          }}
                        >
                          <img
                            style={{
                              marginTop: "0px",
                              margin: "auto",
                              width: "170px",
                              height: "170px",
                            }}
                            src={(data as any)?.image}
                            alt={(data as any)?.title}
                          />
                        </Row>
                        <Row
                          style={{
                            height: "48px",
                            width: "320px",
                            margin: "auto",
                            direction: "ltr",
                            backgroundColor: "transparent",
                          }}
                        >
                          <span
                            style={{
                              width: "32px",
                              height: "32px",
                              textAlign: "center",
                            }}
                          >
                            <TedSaveIcon />
                          </span>
                          <span
                            style={{
                              width: "32px",
                              height: "32px",
                              textAlign: "center",
                            }}
                          >
                            <TedShareIcon />
                          </span>
                        </Row>
                        <Row
                          style={{
                            height: "18px",
                            width: "320px",
                            margin: "auto",
                            direction: "ltr",
                            backgroundColor: "transparent",
                          }}
                        >
                          <div
                            style={{
                              fontFamily: "YekanBakhVF",
                              fontSize: "10px",
                              fontWeight: "450",
                              display: "inline-flex",
                              color: ColorPalette.gray[500],
                            }}
                          >
                            <span> آیتم &nbsp;</span>
                            <span>
                              {convertToPersianNumbers(
                                data?.noticeDetails?.length
                              )}
                            </span>
                            <span style={{ marginLeft: "4px" }}>
                              <TedItemsIcon />
                            </span>
                            <span
                              style={{ marginLeft: "8px", marginRight: "8px" }}
                            >
                              <TedLineIcon />
                            </span>
                            <span>{convertToPersianNumbers(3)}</span>
                            <span style={{ marginLeft: "4px" }}>
                              <TedEyeIcon />
                            </span>
                            <span
                              style={{ marginLeft: "8px", marginRight: "8px" }}
                            >
                              <TedLineIcon />
                            </span>
                            <span>{(data as any)?.dateString} </span>

                            <span style={{ marginLeft: "4px" }}>
                              <TedClockIcon />
                            </span>
                          </div>
                        </Row>
                        <Row
                          style={{
                            height: "50px",

                            marginTop: "24px",
                            marginRight: "20px",
                            marginLeft: "20px",
                          }}
                        >
                          <Col
                            style={{
                              fontSize: "14px",
                              fontWeight: "450",
                              lineHeight: "25.2px",
                            }}
                          >
                            {data?.title}
                          </Col>
                        </Row>
                        <Row style={{ width: "100%" }}>
                          <Col style={{ width: "100%" }}>
                            <Row
                              style={{
                                width: "314px",
                                margin: "auto",
                                marginTop: "20px",
                                textAlign: "center",
                              }}
                            >
                              <Col style={{ width: "157px" }}>
                                <span
                                  onClick={() => setOpenDrawer(true)}
                                  style={{
                                    fontFamily: "YekanBakhVF",
                                    display: "inline-flex",
                                    color: ColorPalette.primaryBlue[500],
                                  }}
                                >
                                  <TedFarayandIcon />
                                  &nbsp; فرآیند آگهی (
                                  {convertToPersianNumbers(
                                    data?.noticeLevels?.length
                                  )}
                                  )
                                </span>
                              </Col>
                              <Col style={{ width: "157px" }}>
                                <span
                                  onClick={() => setOpenDrawerFile(true)}
                                  style={{
                                    fontFamily: "YekanBakhVF",
                                    display: "inline-flex",
                                    color: ColorPalette.primaryBlue[500],
                                  }}
                                >
                                  <TedFileIcon />
                                  &nbsp; فایل پیوست (
                                  {FileLoadedView?.length === undefined
                                    ? 0
                                    : convertToPersianNumbers(
                                        FileLoadedView?.length
                                      )}
                                  )
                                </span>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row
                          style={{
                            marginTop: "24px",
                            marginRight: "20px",
                            marginLeft: "20px",
                          }}
                        >
                          <Col>{data?.description}</Col>
                        </Row>
                        <Row
                          style={{
                            bottom: "0px",
                            height: "84px",
                            width: "100%",
                            margin: "auto",
                          }}
                        >
                          <Col style={{ marginTop: "20px", margin: "auto" }}>
                            {" "}
                            <CustomButton
                              disabled
                              customType="Secondary"
                              hasTitle
                              customSize="XLarge"
                              style={{ width: "152px", marginLeft: "8px" }}
                            >
                              گفتگو
                            </CustomButton>
                            <a href={`#${data?.noticeDetails[0]?.id}`}>
                              <CustomButton
                                onClick={() => {}}
                                customType="Primary"
                                hasTitle
                                customSize="XLarge"
                                style={{ width: "152px", marginRight: "8px" }}
                              >
                                ارسال پیشنهاد
                              </CustomButton>
                            </a>
                          </Col>
                        </Row>
                      </section>

                      {data?.noticeDetails?.map((p: any) => {
                        return (
                          <section id={p?.id} className="item">
                            <Row
                              style={{
                                height: "18px",
                                width: "320px",
                                margin: "auto",
                                backgroundColor: "transparent",
                              }}
                            >
                              <Row
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  marginTop: "21.5px",
                                }}
                              >
                                <Col style={{ width: "68px" }}>
                                  <a
                                    href={`#${
                                      data?.noticeDetails[
                                        parseInt(
                                          data?.noticeDetails.findIndex(
                                            (s: any) => s.id === p?.id
                                          )
                                        ) - 1
                                      ]?.id
                                    }`}
                                  >
                                    {data?.noticeDetails[
                                      parseInt(
                                        data?.noticeDetails.findIndex(
                                          (s: any) => s.id === p?.id
                                        )
                                      ) - 1
                                    ]?.id !== undefined ? (
                                      <>
                                        <span
                                          style={{ display: "inline-flex" }}
                                        >
                                          <TedArrowRightBlue />
                                        </span>
                                        <span>{"قبلی"}</span>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </a>
                                </Col>
                                <Col
                                  style={{
                                    width: "184px",
                                  }}
                                >
                                  <CustomLabel
                                    customSize="XLarge"
                                    style={{
                                      width: "184px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: "600",
                                      lineHeight: "28.8px",
                                      color: ColorPalette.gray[950],
                                      margin: "auto",
                                    }}
                                  >
                                    آیتم &nbsp;
                                    {parseInt(
                                      data?.noticeDetails.findIndex(
                                        (s: any) => s.id === p?.id
                                      )
                                    ) + 1}
                                    &nbsp; از &nbsp;
                                    {data?.noticeDetails?.length}
                                  </CustomLabel>
                                </Col>
                                <Col style={{ width: "68px" }}>
                                  <a
                                    href={`#${
                                      data?.noticeDetails[
                                        parseInt(
                                          data?.noticeDetails.findIndex(
                                            (s: any) => s.id === p?.id
                                          )
                                        ) + 1
                                      ]?.id
                                    }`}
                                  >
                                    {data?.noticeDetails[
                                      parseInt(
                                        data?.noticeDetails.findIndex(
                                          (s: any) => s.id === p?.id
                                        )
                                      ) + 1
                                    ]?.id !== undefined ? (
                                      <>
                                        <span>{"بعدی"}</span>
                                        <span
                                          style={{ display: "inline-flex" }}
                                        >
                                          <TedArrowLefttBlue />
                                        </span>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </a>
                                </Col>
                              </Row>
                              <Row style={{ marginTop: "32px" }}>
                                <Col>
                                  <TedTitle
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "450",
                                      color: ColorPalette.gray[950],
                                    }}
                                    text={p.title}
                                  />
                                  {}
                                </Col>
                              </Row>
                              <Row style={{ marginTop: "5px", width: "100%" }}>
                                <Col>
                                  <Row>
                                    <Col
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <TedConstructionsGrayIcon />
                                      <span
                                        style={{
                                          fontFamily: "YekanBakhVF",
                                          fontSize: "10px",
                                          fontWeight: "450",
                                          width: "71px",
                                          color: ColorPalette.gray[800],
                                          marginTop: "8px",
                                          marginRight: "3px",
                                        }}
                                      >
                                        واحد
                                      </span>
                                      <span
                                        style={{
                                          fontFamily: "YekanBakhVF",
                                          fontSize: "14px",
                                          fontWeight: "325",
                                          color: ColorPalette.gray[950],
                                          marginTop: "8px",
                                          marginRight: "3px",
                                          width: "48px",
                                        }}
                                      >
                                        {
                                          Units[
                                            Units.findIndex(
                                              (f: any) =>
                                                f.value === p.unit.toString()
                                            )
                                          ].label
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <TedConstructionsGrayIcon />
                                      <span
                                        style={{
                                          fontFamily: "YekanBakhVF",
                                          fontSize: "10px",
                                          fontWeight: "450",
                                          width: "71px",
                                          color: ColorPalette.gray[800],
                                          marginTop: "8px",
                                          marginRight: "3px",
                                        }}
                                      >
                                        تعداد/مقدار
                                      </span>
                                      <span
                                        style={{
                                          fontFamily: "YekanBakhVF",
                                          fontSize: "14px",
                                          fontWeight: "325",
                                          color: ColorPalette.gray[950],
                                          marginTop: "8px",
                                          marginRight: "3px",
                                          width: "48px",
                                        }}
                                      >
                                        {convertToPersianNumbers(p?.count)}
                                      </span>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <TedConstructionsGrayIcon />
                                      <span
                                        style={{
                                          fontFamily: "YekanBakhVF",
                                          fontSize: "10px",
                                          fontWeight: "450",
                                          width: "71px",
                                          color: ColorPalette.gray[800],
                                          marginTop: "8px",
                                          marginRight: "3px",
                                        }}
                                      >
                                        ارزش افزوده
                                      </span>
                                      <span
                                        style={{
                                          fontFamily: "YekanBakhVF",
                                          fontSize: "14px",
                                          fontWeight: "325",
                                          color: ColorPalette.gray[950],
                                          marginTop: "8px",
                                          marginRight: "3px",
                                          width: "48px",
                                        }}
                                      >
                                        {"%"}
                                        {convertToPersianNumbers(p?.vat * 100)}
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col
                                      style={{
                                        width: "119px",
                                        marginLeft: "16px",
                                      }}
                                    >
                                      <Row>
                                        {" "}
                                        <CustomLabel
                                          customSize="XLarge"
                                          style={{
                                            width: "119px",
                                            height: "37px",
                                            fontSize: "14px",
                                            fontWeight: "325",
                                            lineHeight: "28.8px",
                                            color: ColorPalette.gray[900],
                                          }}
                                        >
                                          تعداد / مقدار
                                        </CustomLabel>
                                      </Row>
                                      <Row>
                                        {" "}
                                        <InputWithIcons
                                          onChange={(d) =>
                                            SetAnswereForNoticeDetail(
                                              p.id,
                                              "count",
                                              d.target.value
                                            )
                                          }
                                          disabled
                                          value={p.count}
                                          size="xlarge"
                                          style={{
                                            width: "119px",
                                          }}
                                        ></InputWithIcons>
                                      </Row>
                                    </Col>
                                    <Col style={{ width: "185px" }}>
                                      <Row>
                                        {" "}
                                        <CustomLabel
                                          customSize="XLarge"
                                          style={{
                                            width: "185px",
                                            height: "37px",
                                            fontSize: "14px",
                                            fontWeight: "325",
                                            lineHeight: "28.8px",
                                            color: ColorPalette.gray[900],
                                          }}
                                        >
                                          قیمت واحد(بدون ارزش افزوده)
                                        </CustomLabel>
                                      </Row>
                                      <Row>
                                        <InputWithIcons
                                          onChange={(d) =>
                                            SetAnswereForNoticeDetail(
                                              p.id,
                                              "price",
                                              d.target.value
                                            )
                                          }
                                          value={getAnsweres[
                                            getAnsweres.findIndex(
                                              (f: any) =>
                                                f?.noticeDetailId === p?.id
                                            )
                                          ]?.price
                                            ?.toString()
                                            ?.replace(/[^0-9]/g, "")
                                            ?.replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )}
                                          size="xlarge"
                                          style={{
                                            width: "185px",
                                          }}
                                        ></InputWithIcons>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row style={{ marginTop: "16px" }}>
                                    <Col style={{ width: "320px" }}>
                                      <Row>
                                        <CustomLabel
                                          customSize="XLarge"
                                          style={{
                                            width: "320px",
                                            height: "37px",
                                            fontSize: "14px",
                                            fontWeight: "325",
                                            lineHeight: "28.8px",
                                            color: ColorPalette.gray[900],
                                          }}
                                        >
                                          توضیحات
                                        </CustomLabel>
                                      </Row>
                                      <Row>
                                        <TextArea
                                          placeholder="لطفا شرح را بنویسید . . ."
                                          onChange={(d) =>
                                            SetAnswereForNoticeDetail(
                                              p.id,
                                              "description",
                                              d.target.value
                                            )
                                          }
                                          value={
                                            getAnsweres[
                                              getAnsweres.findIndex(
                                                (f: any) =>
                                                  f?.noticeDetailId === p?.id
                                              )
                                            ]?.description
                                          }
                                          style={{
                                            fontFamily: "YekanBakhVF",
                                            direction: "rtl",
                                            width: "320px",
                                            height: "102px",
                                            borderRadius: "4px",
                                            border: "0.7px 0.7px 0.7px 0.7px",
                                            borderColor: ColorPalette.gray[500],
                                          }}
                                        ></TextArea>
                                      </Row>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row
                                style={{
                                  bottom: "0px",
                                  height: "84px",
                                  width: "100%",
                                }}
                              >
                                <Col style={{ marginTop: "20px" }}>
                                  {" "}
                                  <CustomButton
                                    disabled
                                    customType="Secondary"
                                    hasTitle
                                    customSize="XLarge"
                                    style={{
                                      width: "152px",
                                      marginLeft: "8px",
                                    }}
                                  >
                                    گفتگو
                                  </CustomButton>
                                  <CustomButton
                                    onClick={() => {
                                      //SaveAnswereForNoticeDetail(p?.id);
                                    }}
                                    customType="Primary"
                                    hasTitle
                                    customSize="XLarge"
                                    style={{
                                      width: "152px",
                                      marginRight: "8px",
                                    }}
                                  >
                                    ارسال پیشنهاد
                                  </CustomButton>
                                </Col>
                              </Row>
                            </Row>
                          </section>
                        );
                      })}
                      <section id={"preview"} className="item">
                        <Row
                          style={{
                            width: "100%",
                          }}
                        >
                          <InputWithIcons
                            style={{
                              marginTop: "36px",
                              margin: "auto",
                              width: "288px",
                              height: "40px",
                              fontFamily: "YekanBakhVF",
                              fontSize: "14px",
                              fontWeight: "325",
                            }}
                            LeftIcon={TedSearchIcon}
                            LeftIconEnabled
                            placeholder="جستجو کنید"
                            size={"xlarge"}
                          ></InputWithIcons>
                        </Row>
                        <Row style={{ width: "100%", marginTop: "16px" }}>
                          <Table
                            style={{ margin: "auto", width: "100%" }}
                            columns={columnsTotal}
                            dataSource={getAnsweres}
                            pagination={false}
                          />
                        </Row>
                        <Row style={{ width: "100%", marginTop: "20px" }}>
                          <CustomButton
                            onClick={() => {
                              SubmitChange();
                              //console.log(getAnsweres);
                              // console.log(data?.noticeDetails);
                            }}
                            hasTitle
                            customSize="XLarge"
                            customType="Primary"
                            style={{
                              marginTop: "20px",
                              margin: "auto",
                              width: "320px",
                              height: "48px",
                            }}
                          >
                            تایید و ارسال
                          </CustomButton>
                        </Row>
                      </section>
                    </Card>
                  </Row>
                </Col>
              </Row>
              <Drawer
                title=""
                placement={"bottom"}
                width={360}
                onClose={() => setOpenDrawer(false)}
                open={openDrawer}
              >
                <div>
                  <ol
                    style={{
                      color: "black",
                      textAlign: "right",
                      fontFamily: "YekanBakhVF",
                      fontSize: "16px",
                      fontWeight: "325",
                      lineHeight: "28.8px",
                    }}
                  >
                    {data?.noticeLevels?.map((p: any) => {
                      return <li key={p.key}>{p.level}</li>;
                    })}
                  </ol>
                </div>
              </Drawer>
              <Drawer
                title=""
                placement={"bottom"}
                width={360}
                onClose={() => setOpenDrawerFile(false)}
                open={openDrawerFile}
              >
                <div>
                  {FileLoadedView?.map((p: any) => {
                    return (
                      <div
                        key={p.id}
                        style={{
                          display: "block",
                          cursor: "pointer",
                          fontFamily: "YekanBakhVF",
                        }}
                      >
                        <div style={{ display: "inline-flex" }}>
                          <TedFileAttachedIcon />
                          <span
                            style={{
                              width: "148px",
                              fontSize: "16px",
                              fontWeight: "325",
                            }}
                          >
                            {p.name}
                          </span>

                          <span
                            onClick={() => handleDownload(p.id, p.name)}
                            style={{
                              direction: "ltr",
                              width: "148px",
                              fontSize: "14px",
                              fontWeight: "450",
                              color: ColorPalette.primaryBlue[500],
                              display: "inline-flex",
                            }}
                          >
                            {"دانلود فایل"} <TedDownloadIcon />
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Drawer>
            </>
          )}
        </>
      )}
    </>
  );
};
export default Notice8;
